import { render, staticRenderFns } from "./parameter-monitoring-form.vue?vue&type=template&id=6bf79c8a"
import script from "./parameter-monitoring-form.vue?vue&type=script&lang=js"
export * from "./parameter-monitoring-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports